export default __webpack_public_path__ + "static/media/7_engisoft.8f4cde9b.svg";